import { createAsyncThunk } from '@reduxjs/toolkit';

import { BasicInfoApiPaths } from 'Feature/Common/Common/Constant/ApiPaths/BasicInfoApiPaths';
import { BasicInfoHttpGetService } from 'Feature/Common/Common/Services/BasicInfoHttpService';
import { BasicInfoHttpPutService } from 'Feature/Common/Common/Services/BasicInfoHttpService';
import { AxiosResponse } from 'axios';

export const getReminderById = createAsyncThunk('Reminder/getReminderById', async (query: any) => {
  return await BasicInfoHttpGetService({
    url: `${BasicInfoApiPaths.Reminder.GetReminderById}`,
    params: query,
  });
});

export const updateReminder = createAsyncThunk('Reminder/updateReminder', async (command: any) => {
  return await BasicInfoHttpPutService({
    url: `${BasicInfoApiPaths.Reminder.UpdateReminder}`,
    body: command,

    onResult: (res: AxiosResponse<any, any>): any => {
      return res;
    },
  });
});
